export default "/images/horizontal-logo-white.svg?2231b4c4904eef65da577e3eed3bfd1b";